import { FC, useEffect, useState } from "react"
import { ChrevonRightIcon } from "../../../components/MenuIcons/ChevrotRight";
import { useNavigate, useParams } from "react-router-dom";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { cpfCnpjNoMask } from "../../../functions/mask";
import api from "../../../services/api";
import { UserIcon } from "../../../components/MenuIcons/UserIcon";
import { StarIcon } from "../../../components/MenuIcons/StarIcon";
import { GiftIcon } from "../../../components/MenuIcons/GiftIcon";
import { LightIcon } from "../../../components/MenuIcons/LightIcon";
import { GearIcon } from "../../../components/MenuIcons/GearIcon";
import { CardCustomer } from "../../../components/CardCustomer/cardCustomer";
import image from '../../../assets/images/contaCriada.png'
import { Loading } from "../../../components/Loading"
import useAuth from "../../../hooks/useAuth";


type Options = {
    icon: string,
    title: string,
    subtitle: string,
    route: string,

}

type Route = {
    name: string,
    options: Options[]
}

const IndexPerfil: FC = () => {


    const { pluginspace_id } = useParams();
    const navigate = useNavigate();
    const routes: Route[] = [
        {
            name: 'Minha conta',
            options: [
                {
                    icon: 'user',
                    title: 'Informações pessoais',
                    subtitle: 'Confira seus dados cadastrais',
                    route: `/${pluginspace_id}/profile/info`
                },
                {
                    icon: 'gear',
                    title: 'Configuração da conta',
                    subtitle: 'Preferências de contato e privacidade',
                    route: `/${pluginspace_id}/profile/privacy`
                },
                {
                    icon: 'gear',
                    title: 'Alterar senha',
                    subtitle: 'Atualização de senha',
                    route: `/${pluginspace_id}/profile/new_password`
                },
                {
                    icon: 'light',
                    title: 'Endereços',
                    subtitle: 'Endereços cadastrados',
                    route: `/${pluginspace_id}/profile/addresses`
                }
            ]

        },
        {
            name: 'Compras',
            options: [
                {
                    icon: 'gift',
                    title: 'Meus Pedidos',
                    subtitle: 'Acompanhe suas compras',
                    route: `/${pluginspace_id}/my_orders`
                },
                {
                    icon: 'star',
                    title: 'Produtos favoritos',
                    subtitle: 'Confira sua lista de favoritos',
                    route: `/${pluginspace_id}/favorites`
                }
            ]
        }
    ]

    const [account, setAccount] = useState({
        name: '',
        email: '',
        cpf: ''
    })
    const [loading, setLoading] = useState(false);
    const { getToken } = usePluginspace();
    const { loginInfo, getInitialData } = useAuth()

    const getCustomer = async () => {

        if (loginInfo.id) {
            setLoading(true);
            try {


                await api
                    .post(
                        `/api/customer/filter`,
                        {
                            cpf: loginInfo.identifier,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${await getToken()}`,
                            },
                        }
                    )
                    .then(async (response: any) => {
                        setLoading(false);
                        if (response.data.data.length > 0) {
                            const data = response.data.data[0];
                            const payload = {
                                name: data.name,
                                email: data.email,
                                cpf: data.doc
                            }
                            setAccount(payload)
                        }
                    })
                    .catch((err: any) => {
                        setLoading(false);
                        console.log(err);
                    });
            } catch (error) {
                console.log(error)
                return
            }
        }



    }

    const returnIcon = (value: string) => {

        switch (value) {
            case 'user':
                return <UserIcon />
            case 'gear':
                return <GearIcon />
            case 'light':
                return <LightIcon />
            case 'star':
                return <StarIcon />
            case 'gift':
                return <GiftIcon />
        }

    }

    useEffect(() => {
        getCustomer()
    }, [loginInfo])


    return (
        <>
            {
                loading ? (
                    <div style={{ width: '100%', height: 'calc(100vh)' }}>
                        <Loading
                            type="spinningBubbles"
                            color="#FFF"
                            width={64}
                            height={64}
                        />
                    </div>
                ) : (
                    <div className="conteudoPerfil">
                        <div className="successImage">
                            <img src={image} alt="Logo" />
                        </div>
                        <div className="cardUser">
                            <CardCustomer name={account.name} email={account.email} cpf={account.cpf} show={true} />
                        </div>
                        <div className="infoGeral">

                            {routes.map(opc => (
                                <div className="cardInfoOption">
                                    <h3 className="InfoName">{opc.name}</h3>
                                    {opc.options.map(option => (
                                        <div className="info">
                                            <div className="icon">
                                                {
                                                    returnIcon(option.icon)
                                                }
                                            </div>
                                            <div className="header">
                                                <h4>{option.title}</h4>
                                                <span>{option.subtitle}</span>
                                            </div>
                                            <div className="icon">
                                                <ChrevonRightIcon action={() => navigate(option.route)} />
                                            </div>
                                        </div>
                                    ))

                                    }

                                </div>
                            ))

                            }
                        </div>
                    </div >
                )

            }
        </>
    )
}

export { IndexPerfil }